import { FILTER_TYPES } from './filters.constants';
export const createAdapter = (cb) => cb;
const shadcnAdapters = {
    [FILTER_TYPES.TEXT]: createAdapter(({ value, setValue }) => {
        return {
            value,
            onChange: (e) => {
                setValue(e.target.value);
            },
        };
    }),
    [FILTER_TYPES.NUMBER]: createAdapter(({ value, setValue }) => {
        return {
            value,
            onValueChange: (vals) => setValue(vals.floatValue),
        };
    }),
    [FILTER_TYPES.BOOLEAN]: createAdapter(({ value, setValue }) => {
        return {
            checked: value,
            onCheckedChange: (newValue) => setValue(newValue),
        };
    }),
    [FILTER_TYPES.DATE]: createAdapter(({ value, setValue }) => {
        return {
            selected: value,
            onSelect: (date) => date && setValue(date),
        };
    }),
    [FILTER_TYPES.DATE_RANGE]: createAdapter(({ value, setValue }) => {
        return {
            date: {
                from: value?.st_dt,
                to: value?.ed_dt,
            },
            setDate: (date) => date.from &&
                setValue({
                    st_dt: date.from,
                    ed_dt: date.to,
                }),
        };
    }),
    [FILTER_TYPES.SELECT]: createAdapter(({ value, setValue }) => {
        return {
            value,
            setValue,
        };
    }),
};
export const adapters = {
    shadcn: shadcnAdapters,
};
